/** RFC 0345 S6: the sharing layer installs the authenticated human sender.
 * The generic queue path never guesses a person from editable metadata.
 */
import type { Repo } from '@automerge/automerge-repo/slim'
import type { enqueueRun } from './enqueue-run'

export type SessionPostOptions = NonNullable<Parameters<typeof enqueueRun>[3]>
export type SessionPoster = (
  sessionId: string,
  text: string,
  options: SessionPostOptions,
) => Promise<string>
const posters = new WeakMap<Repo, SessionPoster>()

export function registerSessionPoster(repo: Repo, post: SessionPoster): void {
  posters.set(repo, post)
}

export function sessionPoster(repo: Repo): SessionPoster | undefined {
  return posters.get(repo)
}
